import { useEffect } from 'react'
import styles from './ReleaseNotesModal.module.css'

interface ReleaseNotesModalProps {
    readonly isOpen: boolean
    readonly onClose: () => void
    readonly version: string
    readonly notes: string // Markdown or HTML string
}

export function ReleaseNotesModal({ isOpen, onClose, version, notes }: ReleaseNotesModalProps) {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'unset'
        }
        return () => {
            document.body.style.overflow = 'unset'
        }
    }, [isOpen])

    if (!isOpen) return null

    return (
        <div className={styles.overlay} onClick={onClose} role="presentation">
            <div 
                className={styles.modal} 
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
            >
                <div className={styles.header}>
                    <div className={styles.titleWrapper}>
                        <span className={styles.icon}>🚀</span>
                        <div>
                            <h3 className={styles.title}>¿Qué hay de nuevo?</h3>
                            <div className={styles.versionText}>Bibliotelia v{version}</div>
                        </div>
                    </div>
                </div>
                
                <div className={styles.content}>
                    {/* For now, we render the notes as plain text/simple HTML mapping */}
                    <div dangerouslySetInnerHTML={{ __html: notes }} />
                </div>

                <div className={styles.footer}>
                    <button className={styles.closeButton} onClick={onClose}>
                        ¡Entendido!
                    </button>
                </div>
            </div>
        </div>
    )
}
